import React from 'react'

interface IKDTReviewProps {
  title: string
  review: string
  student: string
  schoolName: string
  onClick: () => void
  isAnonymous: boolean
}

const KDTReviewItem = ({
  title,
  review,
  student,
  schoolName,
  onClick,
  isAnonymous,
}: IKDTReviewProps) => {
  return (
    <div
      onClick={onClick}
      className="box-border flex h-[360px] flex-col overflow-hidden rounded-2xl border border-gray-300 bg-white px-4 py-6"
      key={title}>
      <div className="border-b border-gray-300">
        <div className="w-[23px]">
          <img src="/img/double_quotation_img.png" alt="쌍따옴표" className="w-full" />
        </div>
        <p className="mb-3 mt-2 text-sm font-semibold text-blue-800 md:text-base">{title}</p>
      </div>
      <p className="mb-5 mt-3 line-clamp-[8] text-ellipsis whitespace-pre-line break-words text-sm">
        {review}
      </p>
      <div className="mt-auto text-xs text-gray-500 md:text-sm">
        {schoolName} - {isAnonymous ? '익명' : `${student}님`}
      </div>
    </div>
  )
}

export default KDTReviewItem
